<div class="loginpanel">
  <img src="assets/GroeimeterLogo_2025.gif" />
  <button class="btn btn-light btn-lg" #loginButton (click)="userLogin()">
    {{ "BUTTON_LOGIN" | translate }}
  </button>
</div>
